import React, { useRef, useEffect } from "react";
import { Square } from "../../components";
import { TypeSquare } from "../Square/Square.interface";
import styles from "./FirstGame.module.scss";
import { FirstGameProps } from "./FirstGameInterface";
import { COUNT_WORDS, WORD_LENGTH } from "../../Static/consts";

export const FirstGame: React.FC<FirstGameProps> = (props) => {
  const { onClose, onStart } = props;

  return (
    <div className={styles.firstGame}>
      <div className={styles.formClose} onClick={onClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="none"
        >
          <path
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="m4.757 4.757 8.486 8.486M4.757 13.243l8.486-8.486"
          />
        </svg>
      </div>
      <div className={styles.caption}>Игра «Угадай слово»</div>
      <div className={styles.wrap}>
        <div className={styles.desc}>
          Цель игры: отгадать слово из {WORD_LENGTH} букв за {COUNT_WORDS}{" "}
          попыток.
        </div>
        <div className={styles.inner}>
          <div className={styles.letter}>
            <Square key={1} letter="" typeSquare={TypeSquare.Empty} />
            <div className={styles.letterDesc}>Пустая ячейка</div>
          </div>
          <div className={styles.letter}>
            <Square key={2} letter="б" typeSquare={TypeSquare.NoLetter} />
            <div className={styles.letterDesc}>
              Эта буква не содержится в слове
            </div>
          </div>
          <div className={styles.letter}>
            <Square key={3} letter="б" typeSquare={TypeSquare.ThereLetter} />
            <div className={styles.letterDesc}>
              Эта буква есть в слове, но стоит не на своем месте
            </div>
          </div>
          <div className={styles.letter}>
            <Square key={4} letter="б" typeSquare={TypeSquare.ThisLetter} />
            <div className={styles.letterDesc}>
              Эта буква есть в слове и стоит на своем месте
            </div>
          </div>
          <div className={styles.letter}>
          <div className={styles.helper}>
                    ?
                  </div>
                  <div className={styles.letterDesc}>
                  Подсказка к загадочному слову этапа
                    </div>
          </div>
        </div>
        <div className={styles.desc}>
          При перезагрузке и закрытии окна, игра завершится автоматически.
        </div>
      </div>
      <div style={{ marginTop: "30px" }}>
        <div className={styles.startGameButton} onClick={onStart}>
          Понятно, начнём
        </div>
      </div>
    </div>
  );
};
